import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_EMAIL_SERVER_SETTINGS = {
  enabled: false,
  protocol: "GRAPH",
  acceptUnregistered: false,
  mailboxUsername: "",
  graphTenant: "",
  graphClientId: "",
  graphCertificateAuth: false,
  graphPfxPassword: "",
  graphPfxCert: "",
  password: "",
};

export const INITIAL_STATE = {
  settings: INITIAL_EMAIL_SERVER_SETTINGS,
  edits: {},
  isConnectionTested: false,
  isTesting: false,
};

export const emailServerSlice = createSlice({
  name: "emailServer",
  initialState: INITIAL_STATE,
  reducers: {
    setEmailServerSettings: (state, { payload }) => {
      state.settings = payload;
    },
    setEdits: (state, { payload }) => {
      state.edits = { ...state.edits, ...payload };
    },
    resetEdits: (state) => {
      state.edits = {};
    },
    setIsConnectionTested: (state, { payload }) => {
      state.isConnectionTested = Boolean(payload);
    },
    setIsTesting: (state, { payload }) => {
      state.isTesting = payload;
    },
  },
});

export const {
  setEmailServerSettings,
  setEdits,
  resetEdits,
  setIsConnectionTested,
  setIsTesting,
} = emailServerSlice.actions;

export default emailServerSlice.reducer;
